"use client";
import React, { Fragment } from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PagesTabs from "@/components/pageTabs/tabs";
import { CLOUD_MIGRATION_CONSTANTS } from "@/components/header/header.constants";
import Hero from "./components/hero";
import IntroComponent from "./components/intro";
import MigrationComponent from "./components/migration";
import WhyOnemind from "./components/whyOnemind";
import ComparisonComponent from "./components/comparison";
import PartnershipComponent from "./components/partnership";
import MigrationCta from "./components/migrateCta";
import Faqs from "./components/faqs";

const EC2ToZadaraPage = () => {
  return (
    <Fragment>
      <Box>
        <Hero />
        <PageLayout>
          <PagesTabs props={CLOUD_MIGRATION_CONSTANTS} />
          <IntroComponent />
        </PageLayout>
      </Box>
      <MigrationComponent />
      <PageLayout marginTop={0}>
        <ComparisonComponent />
      </PageLayout>
      <Box>
        <WhyOnemind />
        <PartnershipComponent />
      </Box>
      <PageLayout showContactForm>
        <MigrationCta />
        <Faqs />
      </PageLayout>
    </Fragment>
  );
};

export default EC2ToZadaraPage;
